import { render, staticRenderFns } from "./SaveConsumerCoupons.vue?vue&type=template&id=68d8c94d"
import script from "./SaveConsumerCoupons.vue?vue&type=script&lang=js"
export * from "./SaveConsumerCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports